'use client';

import { IconGallery2 } from '@/features/icons';
import { cn } from '@/utils/cn';
import GalleryCarousel from './carousel';
import { useLanguage } from '../../context/language-context-provider';
import SectionHeading from '../section-heading';
const Gallery = () => {
  const {
    t,
    language
  } = useLanguage();
  const isEn = language === 'en';
  return <div className='homepage-container lg:mt-40' data-sentry-component="Gallery" data-sentry-source-file="index.tsx">
            <div className={cn('relative flex flex-col items-center gap-5.5 rounded bg-primary-main pb-3 pt-5 lg:rounded-xl lg:pb-9 lg:pt-18', isEn ? 'pl-3 pr-2 lg:pl-7.5' : 'pl-2 pr-3 lg:pr-7.5')}>
                <SectionHeading title={t('gallery')} icon={<IconGallery2 />} isRevertColors className={cn('lg:absolute lg:top-0 lg:-translate-y-1/2', isEn ? 'lg:left-7.5' : 'lg:right-7.5 lg:mr-8')} data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx" />

                <GalleryCarousel data-sentry-element="GalleryCarousel" data-sentry-source-file="index.tsx" />
            </div>
        </div>;
};
export default Gallery;